"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.WeeklyCalendar = void 0;
var jsx_runtime_1 = require("@emotion/react/jsx-runtime");
var clsx_1 = __importDefault(require("clsx"));
var moment_timezone_1 = __importDefault(require("moment-timezone"));
require("./weeklyCalendar.css");
var WeeklyCalendar = function (props) {
    var pivot = props.pivotDate ? props.pivotDate : (0, moment_timezone_1.default)();
    var days = Array(7)
        .fill('')
        .map(function (el, index) { return pivot.clone().add(-3 + index, 'day'); });
    return ((0, jsx_runtime_1.jsx)("div", __assign({ className: "weekly-calendar" }, { children: days.map(function (d) { return ((0, jsx_runtime_1.jsxs)("div", __assign({ className: "day-element", onClick: function () { return props.onClick && props.onClick(d); } }, { children: [(0, jsx_runtime_1.jsx)("div", __assign({ className: "day-name" }, { children: d.format('dd')[0].toUpperCase() + d.format('dd')[1] })), (0, jsx_runtime_1.jsx)("div", __assign({ className: (0, clsx_1.default)('day-number', props.dateSelected && d.format('DD') === props.dateSelected.format('DD')
                        ? // && d.format('DD') !== pivot.format('DD')
                            'selected'
                        : undefined, props.onClick ? 'clickable' : undefined, d.format('DD') === pivot.format('DD') ? 'today' : undefined) }, { children: d.format('DD') }))] }), d.format('dd'))); }) })));
};
exports.WeeklyCalendar = WeeklyCalendar;
//# sourceMappingURL=WeeklyCalendar.js.map